import React, { useState } from "react"
import style from "./suppliers.mod.scss"
import { GatsbyImage } from "gatsby-plugin-image"
import { Select } from "@components"
import { Switch, FormControlLabel, FormGroup } from "@mui/material"

const Suppliers = ({ items }) => {
  const [preferredFilter, setPreferredFilter] = useState(false)
  const [stateFilter, setStateFilter] = useState("")
  const [industryFilter, setIndustryFilter] = useState("")

  const handlePreferredChange = event => {
    setPreferredFilter(event.target.checked)
  }

  const handleStateChange = event => {
    setStateFilter(event.target.value)
  }

  const handleIndustryChange = event => {
    setIndustryFilter(event.target.value)
  }

  const states = Array.from(new Set(items.map(item => item.state)))
  const industries = Array.from(new Set(items.map(item => item.industry)))

  const filteredItems = items
    .filter(item => {
      return (
        (!preferredFilter || (preferredFilter && item.preferred)) &&
        (stateFilter === "" || item.state === stateFilter) &&
        (industryFilter === "" || item.industry === industryFilter)
      )
    })
    .sort((a, b) => {
      if (a.preferred === b.preferred) {
        return a.name.localeCompare(b.name)
      }
      return a.preferred ? -1 : 1
    })

  return (
    <div className={style.suppliers__wrap}>
      <div className={style.suppliers__filters}>
        <Select
          label="State"
          name="state"
          options={[
            { value: "", text: "All" },
            ...states.map(state => ({ value: state, text: state }))
          ]}
          onChange={handleStateChange}
          value={stateFilter}
        />
        <Select
          label="Industry"
          name="industry"
          options={[
            { value: "", text: "All" },
            ...industries.map(industry => ({ value: industry, text: industry }))
          ]}
          onChange={handleIndustryChange}
          value={industryFilter}
        />
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={preferredFilter}
                onChange={handlePreferredChange}
                name="preferred"
                color="primary"
              />
            }
            label="Preferred Supplier"
          />
        </FormGroup>
      </div>
      <div className={style.suppliers}>
        {filteredItems.map(
          ({
            name,
            industry,
            phone,
            website,
            state,
            city,
            image,
            preferred
          }) => {
            const classes = [style.item]
            preferred && classes.push(style.item__active)

            return (
              <div className={classes.join(" ")} key={name}>
                <div className={style.item__image}>
                  <GatsbyImage
                    image={image.gatsbyImageData}
                    loading={"lazy"}
                    alt={image.alt || ""}
                  />
                </div>
                <div className={style.item__details}>
                  <h4 className={style.item__detail}>{name}</h4>
                  <div className={style.item__detail}>
                    <span className={style.item__heading}>{"Industry:"}</span>
                    <span>{industry}</span>
                  </div>
                  <div className={style.item__detail}>
                    <span className={style.item__heading}>{"State:"}</span>
                    <span>{state}</span>
                  </div>
                  <div className={style.item__detail}>
                    <span className={style.item__heading}>{"City:"}</span>
                    <span>{city}</span>
                  </div>
                  {phone && (
                    <div className={style.item__detail}>
                      <span className={style.item__heading}>{"Phone:"}</span>
                      <span>{phone}</span>
                    </div>
                  )}
                  {website && (
                    <div className={style.item__detail}>
                      <span className={style.item__heading}>{"Website:"}</span>
                      <a
                        href={website}
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                      >
                        {"View website"}
                      </a>
                    </div>
                  )}
                </div>
                {preferred && <Icon />}
              </div>
            )
          }
        )}
      </div>
    </div>
  )
}

export default Suppliers

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="220"
      height="220"
      fill="none"
      viewBox="0 0 220 220"
    >
      <path
        fill="#005B8D"
        d="M110 219.7c60.585 0 109.7-49.115 109.7-109.7C219.7 49.414 170.585.3 110 .3 49.414.3.3 49.414.3 110c0 60.585 49.114 109.7 109.7 109.7z"
      ></path>
      <path
        fill="#fff"
        d="M66.8 155.5l4 11.3 4-11.3h3L72 170.4h-2.4l-5.9-14.9h3.1zM89.9 167.8v2.5H79.5v-14.9h10.2v2.5h-7.3v3.6h6.3v2.4h-6.3v3.9h7.5zM92.1 170.4v-14.9h6.6c.7 0 1.301.1 1.901.4.6.3 1.1.7 1.5 1.1.4.5.7 1 1 1.6.2.6.4 1.2.4 1.8 0 1-.2 1.8-.7 2.6-.5.8-1.1 1.4-2 1.7l3.4 5.6h-3.3l-3-5H95v5h-2.9v.1zm2.9-7.6h3.6c.3 0 .5 0 .7-.2.2-.2.4-.3.6-.5.201-.2.301-.5.401-.8 0-.3.1-.6.1-.9 0-.3 0-.7-.2-1-.1-.3-.3-.5-.5-.8-.2-.3-.4-.4-.7-.5-.2-.1-.5-.2-.7-.2h-3.5v4.8l.2.1zM106.101 170.4v-14.9h2.9v14.9h-2.9zM112.101 170.4v-14.9h10v2.5h-7.1v3.8h5.9v2.4h-5.9v6.2h-2.9zM124.101 170.4v-14.9h2.9v14.9h-2.9zM140.501 167.8v2.5h-10.4v-14.9h10.2v2.5h-7.3v3.6h6.3v2.4h-6.3v3.9h7.5zM142.8 170.4v-14.9h5.4c1.2 0 2.3.2 3.2.6.9.4 1.7.9 2.3 1.6.6.7 1.1 1.5 1.4 2.4.3.9.5 1.9.5 2.9s-.2 2.2-.5 3.1c-.3.9-.8 1.7-1.5 2.4-.6.7-1.4 1.2-2.3 1.5-.9.4-1.9.5-3 .5h-5.4l-.1-.1zm9.8-7.5c0-.7 0-1.4-.3-2-.2-.6-.5-1.1-.9-1.6-.4-.4-.8-.8-1.4-1-.6-.2-1.2-.4-1.9-.4h-2.5v9.8h2.5c.7 0 1.3-.1 1.9-.4.6-.3 1-.6 1.4-1 .4-.4.7-1 .9-1.6.2-.6.3-1.3.3-2v.2zM69.2 176.5l4 11.3 4-11.3h3l-5.8 14.9H72l-5.9-14.9h3.1zM92.2 188.8v2.5H81.8v-14.9H92v2.5h-7.3v3.6H91v2.4h-6.3v3.9h7.5zM97.4 181.8v9.6h-2.9v-14.9h2.2l7.8 9.8v-9.8h2.9v14.9H105l-7.7-9.6h.1zM110.5 191.4v-14.9h5.4c1.2 0 2.3.2 3.2.6.9.4 1.7.9 2.3 1.6.6.7 1.1 1.5 1.4 2.4.3.9.5 1.9.5 2.9s-.2 2.2-.5 3.1c-.3.9-.8 1.7-1.5 2.4-.6.7-1.4 1.2-2.3 1.5-.9.4-1.9.5-3 .5h-5.4l-.1-.1zm9.9-7.5c0-.7 0-1.4-.3-2-.2-.6-.5-1.1-.9-1.6-.4-.4-.8-.8-1.4-1-.6-.2-1.2-.4-1.9-.4h-2.5v9.8h2.5c.7 0 1.3-.1 1.9-.4.6-.3 1-.6 1.4-1 .4-.4.7-1 .9-1.6.2-.6.3-1.3.3-2v.2zM131.901 191.5c-1.1 0-2.1-.2-3-.6-.9-.4-1.7-1-2.3-1.7-.6-.7-1.1-1.5-1.5-2.4-.4-.9-.5-1.8-.5-2.8 0-1 .2-1.9.6-2.9.4-.9.9-1.7 1.5-2.4.7-.7 1.4-1.3 2.3-1.7.9-.4 1.9-.6 2.9-.6s2.1.2 3 .7c.9.4 1.6 1 2.3 1.7.7.7 1.1 1.5 1.5 2.4.3.9.5 1.8.5 2.8 0 1-.2 1.9-.5 2.8-.4.9-.9 1.7-1.5 2.4s-1.4 1.2-2.3 1.7c-.9.5-1.9.6-2.9.6h-.1zm-4.3-7.6c0 .6 0 1.3.3 1.9.2.6.5 1.1.9 1.6s.8.8 1.4 1.1c.5.3 1.2.4 1.8.4.6 0 1.3-.1 1.9-.4.6-.3 1-.7 1.4-1.1.4-.5.7-1 .8-1.6.1-.6.3-1.2.3-1.8 0-.6-.1-1.3-.3-1.9-.2-.6-.5-1.1-.9-1.6s-.8-.8-1.4-1.1c-.5-.3-1.1-.4-1.8-.4s-1.3.1-1.9.4c-.5.3-1 .7-1.4 1.1-.4.5-.6 1-.8 1.6-.2.6-.3 1.2-.3 1.8zM141.4 191.4v-14.9h6.6c.7 0 1.3.1 1.9.4.6.3 1.1.7 1.5 1.1.4.5.7 1 1 1.6.2.6.4 1.2.4 1.8 0 1-.2 1.8-.7 2.6-.5.8-1.1 1.4-2 1.7l3.4 5.6h-3.3l-3-5h-2.9v5h-2.9v.1zm2.9-7.6h3.6c.3 0 .5 0 .7-.2.2-.2.4-.3.6-.5.2-.2.3-.5.4-.8 0-.3.1-.6.1-.9 0-.3 0-.7-.2-1-.1-.3-.3-.5-.5-.8-.2-.3-.4-.4-.7-.5-.2-.1-.5-.2-.7-.2h-3.5v4.8l.2.1zM152.6 61.4c0 24.9.1 38.7-5.2 49.5-5.4 10.9-15.5 17.6-36 28.6l-2.4 1.3-2.4-1.3c-20.6-10.9-30.7-17.6-36-28.6-5.4-10.8-5.3-24.6-5.2-49.5V46.6l4.7-.3c23-1.7 35.1-14.4 35.2-14.5l3.8-4 3.7 4.1s9.5 10 27.6 13.5l-7.5 8.7c-11.6-3.2-19.5-8.4-23.8-11.9-5.4 4.4-16.6 11.6-33.4 13.8v5.6c0 23.4-.1 36.3 4.2 45 4 8 12.3 13.7 29.3 22.8 16.9-9.1 25.3-14.8 29.3-22.8 3.5-7.2 4.1-17.2 4.2-33.7L152.9 61v.7l-.3-.3zm-44.2 25.9c-.2.3-.6.3-.9 0l-9.9-9.9c-.2-.2-.6-.2-.8 0l-8.1 8.1c-.2.2-.2.6 0 .8l19.7 19.7c.2.2.7.2.9 0l45.3-52.9c.2-.3.2-.6 0-.9l-8.8-7.3c-.3-.2-.6-.2-.8 0l-36.4 42.2-.2.2z"
      ></path>
    </svg>
  )
}
